import { http } from '@/api/http';
import { ApiResponseBody } from '@/api/types';
import { getComposerApiUrl } from './composer.paths';
import { BulkArrivalCustomerResponse, DeviceTracking, DeviceTrackingQueryParams } from './composer.types';

const getCaseDeviceTracking = async (caseId: string): Promise<DeviceTracking> => {
  return new Promise((resolve, reject) => {
    http.get<ApiResponseBody<DeviceTracking>>(getComposerApiUrl.caseDeviceTracking(caseId)).then((res) => {
      if (res.data.hasError) {
        reject(res.data.error);
      } else {
        resolve(res.data.data);
      }
    });
  });
};

const getCaseDeviceTrackingCustomer = async (
  caseId: string,
  queryParams?: DeviceTrackingQueryParams,
): Promise<DeviceTracking> => {
  const res = await http.get<ApiResponseBody<DeviceTracking>>(getComposerApiUrl.caseDeviceTrackingCustomer(caseId), {
    params: queryParams,
  });
  return res.data.data;
};

// TODO: Update type when backend provides proper schema
const getBulkArrival = async (caseIds: string[]) => {
  const res = await http.get<ApiResponseBody<unknown>>(getComposerApiUrl.bulkArrival(), {
    params: { caseIds },
    paramsSerializer: { indexes: null },
  });
  return res.data.data;
};

const getBulkArrivalCustomer = async (caseIds: string[]): Promise<BulkArrivalCustomerResponse> => {
  const res = await http.get<ApiResponseBody<BulkArrivalCustomerResponse>>(getComposerApiUrl.bulkArrivalCustomer(), {
    params: { caseIds },
    paramsSerializer: { indexes: null },
  });
  return res.data.data;
};

export const composerApiFetcher = {
  getCaseDeviceTracking,
  getCaseDeviceTrackingCustomer,
  getBulkArrival,
  getBulkArrivalCustomer,
};
